/* Just Brilliant product sharing. Uses a public product URL, without preview tokens. */
if (!customElements.get('jb-product-share')) customElements.define('jb-product-share', class extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const signal = this.abort.signal;
    const button = this.querySelector('button');
    const status = this.querySelector('[role="status"]');
    const fallback = this.querySelector('input');
    button.hidden = false;
    this.sync = () => {
      const source = this.closest('.product-information--inner')?.querySelector('[data-jb-share-state]');
      this.variant = source?.dataset.variantId;
      const sku = source?.dataset.sku || '';
      const reference = this.querySelector('[data-reference]');
      if (reference.textContent !== sku) reference.textContent = sku;
      this.querySelector('.jb-product-reference').hidden = !sku;
    };
    this.sync();
    const info = this.closest('.product-information--inner');
    this.observer = new MutationObserver(this.sync);
    if (info) this.observer.observe(info, {childList:true, subtree:true, attributes:true, attributeFilter:['data-variant-id','data-sku']});
    button.addEventListener('click', async () => {
      if (this.busy) return;
      this.busy = true;
      status.textContent = '';
      fallback.hidden = true;
      const url = new URL(this.dataset.url);
      if (this.variant) url.searchParams.set('variant', this.variant);
      try {
        if (navigator.share) {
          await navigator.share({title:this.dataset.title, url:url.href});
        } else {
          await navigator.clipboard.writeText(url.href);
          status.textContent = 'Product link copied.';
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          fallback.value = url.href;
          fallback.hidden = false;
          fallback.focus();
          fallback.select();
          status.textContent = 'Select and copy this product link.';
        }
      } finally { this.busy = false; }
    }, {signal});
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.observer?.disconnect();
    this.abort = null;
  }
});
